import { render, staticRenderFns } from "./Smtp.vue?vue&type=template&id=4d47e995"
import script from "./Smtp.vue?vue&type=script&lang=js"
export * from "./Smtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d47e995')) {
      api.createRecord('4d47e995', component.options)
    } else {
      api.reload('4d47e995', component.options)
    }
    module.hot.accept("./Smtp.vue?vue&type=template&id=4d47e995", function () {
      api.rerender('4d47e995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mailDriver/Smtp.vue"
export default component.exports